import React, { Component } from "react";
import ReadAxios from "../axiosComponent/read";
// import MiniPlaceholder from "./miniPlaceHolder";
import { translate } from "react-i18next";
import isEmpty from "lodash/isEmpty";

export class GetCity extends Component {
  constructor(props) {
    super(props);

    this.state = {
      city: [],
    };
  }

  async componentDidMount() {
    let dataArray =
      (await ReadAxios({
        url: `Citymaster/${this.props.cityId}`,
      })) || [];
    dataArray = isEmpty(dataArray) ? [] : dataArray.data.resultSet;
    this.setState({ city: dataArray || [] });
  }

  render() {
    const { t } = this.props;
    const { city } = this.state;

    return (
    // <span>{"Na"}</span>
            <span>{city.length > 0 ? city[0].cityName : "NA"}</span>
    ) 
  }
}

export default translate("shipment")(GetCity);
